// export const COUNTERPARTIES_COLUMN_KEYS = {
//   GUID: 'guid',
//   NAME: 'name',
//   RESERVE_ACC: 'reserve_acc',
//   EMISSION_ACC: 'emission_acc',
//   PROCESSING_ACC: 'processing_acc',
//   TOTAL_AMOUNT: 'total_amount',
//   ISSUE: 'issue',
//   BURN: 'burn',
// } as const;
export enum ECounterpartiesTableColumns {
  Guid = 'guid',
  Name = 'name',
  ReserveAcc = 'reserve_acc',
  EmissionAcc = 'emission_acc',
  ProcessingAcc = 'processing_acc',
  TotalAmount = 'total_amount',
  Issue = 'issue',
  Burn = 'burn',
}
